import { Stack, Typography } from '@mui/material';

import { DocumentStatus } from '@/types/document';

import { getDataTestId } from '@/utils/browser';

import { StatusProgressDot } from './Indicator.styled';

export type StatusProgressDotsProps = {
  className?: string;
  dots: (DocumentStatus | undefined)[];
  text?: string;
};

export function StatusProgressDots({
  className,
  dots,
  text,
}: StatusProgressDotsProps) {
  const progress = dots.filter(
    status =>
      status === DocumentStatus.Approved || status === DocumentStatus.Completed,
  ).length;

  return (
    <Stack
      className={className}
      direction="column"
      alignItems="center"
      gap={1.25}
      {...getDataTestId(`progress-dots`)}
    >
      <Stack gap={1}>
        {dots.map((status, index) => (
          <StatusProgressDot
            key={`progress-dot-${index}`}
            {...getDataTestId(`progress-dot-${index}`)}
            status={status}
          />
        ))}
      </Stack>
      <Typography variant="body2" textAlign="center">
        {text || `${progress}/${dots.length}`}
      </Typography>
    </Stack>
  );
}
